export default class Runner {
    runJS(script, vars) {
        let keys = Object.keys(vars)
        let values = Object.values(vars)

        let result = new Function(...keys, `${script} ; return exports.default || exports;`)

        return result(...values)
    }
}